import { useNavigate } from 'react-router-dom';
import { GRIA_URL } from './constants';

export const redirectToCompany = (redirectPath?: string) => {
  const path = redirectPath || '/company/jobs';
  const url = `${GRIA_URL}${path}`;

  window.location.replace(url);
};

export const redirectToCandidate = (redirectPath?: string) => {
  const path = redirectPath || '/candidate/jobs';
  const url = `${GRIA_URL}${path}`;

  window.location.replace(url);
};

export const redirectToFormCompany = (redirectPath?: string) => {
  const navigate = useNavigate();
  navigate(`${redirectPath}`);
};
